import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ColumnQuoteMediaBlock}
 */

const ColumnQuoteMedia = ({
    autoplay,
    quote,
    richText,
    richTextCaption,
    backgroundColor,
    media
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} col-padding pt-16 md:pt-24 pb-16 grid sm:grid-cols-2 gap-y-16 sm:gap-y-0 gap-x-8 md:gap-x-16 rounded-lg`}>
            <div className='w-full content-center'>
                <h2 className='type-style-serif-h2 max-w-[550px]'>
                    {quote}
                </h2>
                {richText && (
                    <div
                        className='rich-text mt-16 max-w-[560px]'
                        dangerouslySetInnerHTML={{__html:richText}} />
                )}
            </div>
            <div className='flex flex-col'>
                <figure className='rounded-lg overflow-hidden h-[193px] sm:h-[268px] md:h-[380px]'>
                    <Media {
                        ...{
                            ...media,
                            ...(media.image ? {
                                image: {
                                    ...media?.image,
                                    className: 'h-full w-full object-cover',
                                    containerStyle: {
                                        height: '100%'
                                    },
                                    containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                }
                            } : {}),
                            ...(media.videoEmbed ? {
                                videoEmbed: {
                                    ...media.videoEmbed,
                                    autoPlay: autoplay,
                                    poster: media?.videoEmbed?.poster || media?.videoEmbed?.embed?.thumbnailUrl
                                }
                            } : {} ),
                            ...(media.video ? {
                                video: {
                                    ...media.video,
                                    autoPlay: autoplay,
                                    showControls: !autoplay,
                                    loop: autoplay,
                                }
                            } : {} )
                        }
                    }/>
                </figure>
                {richTextCaption && (
                    <figcaption
                        className='rich-text type-style-sans-body mt-8 w-full md:w-4/6 module-caption'
                        dangerouslySetInnerHTML={{__html:richTextCaption}} />
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ColumnQuoteMedia;
